import {
    GET_COUNTRY,
    SET_LAST_REFRENCE_ID,
    GET_CONNECTED_BANKS,
    CONNECT_BANK,
    GET_POCKYT_BANK_FORM_DATA,
    CLEAR_BANK_FORMDATA,
    GET_POCKYT_FEES,
    REPLACE_BANK,
    SET_PAYMENT_OPTION,
    SET_FORM_VALUES,
} from '../actions/actionTypes';

const initialState = {
    countries: [],
    paymentMethods: [],
    formAttributeSet: false,
    defaultCountry: null,
    skip: [4],
    lastRefId: null,
    addbank: false,
    connectedBanks: [],
    connectBank: false,
    pocFormAttribute: null,
    pocFees: null,
    paymentOption: null,
    formValues: {}
}
function TransferReducer(state = initialState, action) {
    switch (action.type) {
        case GET_COUNTRY:
            return {
                ...state,
                countries: action.payload.countryList,
                defaultCountry: action.payload.selectedCountry
            }
        case SET_LAST_REFRENCE_ID: {
            return {
                ...state,
                lastRefId: action.payload
            }
        }
        case GET_CONNECTED_BANKS: {
            return {
               ...state,
                connectedBanks: action.payload
            }
        }
        case CONNECT_BANK: {
            return {
               ...state,
                connectBank: action.payload
            }
        }
        case GET_POCKYT_BANK_FORM_DATA: {
            return {
               ...state,
                pocFormAttribute: action.payload
            }
        }
        case CLEAR_BANK_FORMDATA: {
            return {
                ...state,
                pocFormAttribute: null,
            }
        }
        case GET_POCKYT_FEES: {
            return {
               ...state,
                pocFees: action.payload
            }
        }
        case REPLACE_BANK: {
            return {
               ...state,
                bankToReplace: action.payload
            }
        }
        case SET_PAYMENT_OPTION: {
            return {
                ...state,
                paymentOption: action.payload
            }
        }
        case SET_FORM_VALUES: {
            return {
                ...state,
                formValues: action.payload
            }
        }
        default: return state;
    }
}
export default TransferReducer;